export default "__VITE_ASSET__79e365cc__"